import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import AccountSidebar from '../components/AccountSidebar';

const UserDashboardLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-100" data-testid="user-dashboard-layout">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex gap-6">
          {/* Mobile hamburger */}
          <button
            onClick={() => setSidebarOpen(true)}
            className="lg:hidden fixed bottom-4 left-4 z-40 w-12 h-12 rounded-full bg-zl-orange text-white shadow-lg flex items-center justify-center hover:bg-zl-orange-600 transition-colors"
            data-testid="sidebar-mobile-toggle"
          >
            <Menu className="w-5 h-5" />
          </button>

          {/* Mobile sidebar overlay */}
          {sidebarOpen && (
            <div className="fixed inset-0 z-50 lg:hidden">
              <div
                className="absolute inset-0 bg-black/50"
                onClick={() => setSidebarOpen(false)}
              />
              <div className="absolute left-0 top-0 bottom-0 w-72 bg-white shadow-xl animate-in slide-in-from-left duration-200">
                <div className="flex items-center justify-between p-3 border-b">
                  <span className="font-semibold text-sm text-gray-700">Menu</span>
                  <button
                    onClick={() => setSidebarOpen(false)}
                    className="p-1 rounded hover:bg-gray-100"
                    data-testid="sidebar-mobile-close"
                  >
                    <X className="w-5 h-5" />
                  </button>
                </div>
                <div onClick={() => setSidebarOpen(false)}>
                  <AccountSidebar />
                </div>
              </div>
            </div>
          )}

          {/* Desktop sidebar */}
          <div className="hidden lg:block w-64 shrink-0">
            <AccountSidebar />
          </div>

          {/* Page content */}
          <div className="flex-1 min-w-0">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDashboardLayout;
